import SySlider from "./sy-slider";


export default SySlider